module.exports = __webpack_public_path__ + "img/Dashboard.9cc3a10c.png";